var __jsx = React.createElement;
import React from "react";
import stl from "./PageDesc.module.css";
var PageDesc = function PageDesc(_ref) {
  var content = _ref.content;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.ST_moreInfoContainer,
    dangerouslySetInnerHTML: {
      __html: content
    }
  }));
};
export default PageDesc;